import {HighLowTransformer as Transformer} from './high-low-transformer'
import { FEATURES } from '..'

/*
 * Used to transform from the Albers USA to a specific state
 */
export default class UsaStateTransformer extends Transformer {

  static match (d0, d1) {
    if (!d0) {
      return false
    }

    return (d0.node.key == FEATURES.USA && d1.node.parentKey == FEATURES.USA) // usa to state
      || (d1.node.key == FEATURES.USA && d0.node.parentKey == FEATURES.USA)   // state to usa
  }

  /*
   * High resolution is always the state
   */
  resolutions (enter, exit) {
    let high = enter.datum().node.parentKey == FEATURES.USA ? enter : exit
      , low = enter.datum().node.key == FEATURES.USA ? enter : exit

    return {high, low}
  }

}
